<div
  [formGroup]="transferAmountForm"
  class="transfer-amount-container flex flex-col items-center text-center lg:mx-0 lg:flex-row lg:items-start"
  [class.rounded-md-b]="!collapsibleTransferAmountForm"
  [class.collapsible-transfer-amount-form]="collapsibleTransferAmountForm">
  <div class="input-group px-8 lg:pl-4 lg:pr-0">
    <label
      class="amount-form-label mb-5"
      for="sourceAmount"
      [innerHTML]="loyaltyCurrencyName"></label>
    <div class="transfer-input">
      <button
        type="button"
        class="minus-plus-container minus-button p-0 focus-link"
        (click)="subtractPoints()"
        [attr.aria-disabled]="minusIconTheme() === 'disabled'"
        [attr.aria-label]="
          'accessibility.transfer_v2.checkout.subtract'
            | translate: { loyaltyCurrency: loyaltyCurrencyName }
        ">
        <rd-shared-icon
          class="minus-plus-icon minus-icon"
          [iconSymbol]="'icon-minus'"
          [iconTheme]="minusIconTheme()"
          [ngClass]="iconActiveClass()"></rd-shared-icon>
      </button>
      <mat-form-field [color]="'accent'" class="mat-field">
        <input
          matInput
          [readonly]="currencyConversionLoading"
          type="text"
          formControlName="sourceAmount"
          [placeholder]="
            loyaltyProgram.transferRate.denomination | localizeNumber
          "
          aria-atomic="true"
          [attr.aria-label]="loyaltyCurrencyName"
          [attr.aria-live]="'polite'" />
      </mat-form-field>
      <button
        type="button"
        class="minus-plus-container p-0 focus-link"
        (click)="addPoints()"
        [attr.aria-label]="
          'accessibility.transfer_v2.checkout.add'
            | translate: { loyaltyCurrency: loyaltyCurrencyName }
        "
        [attr.aria-disabled]="plusIconTheme() === 'disabled'">
        <rd-shared-icon
          class="minus-plus-icon icon-active plus-icon"
          [iconSymbol]="'icon-plus'"
          [iconTheme]="plusIconTheme()"></rd-shared-icon>
      </button>
    </div>
    <mat-hint
      class="source-amount-hint"
      [innerHTML]="
        'transfer_v2.checkout.hint.must_be_multiples_of'
          | translate: { amount: formattedDenomination }
      "></mat-hint>
    <mat-error class="required-source-amount" *ngIf="isSourceAmountEmpty()">
      {{ 'transfer_v2.checkout.error.required_amount' | translate }}
    </mat-error>
    <mat-error
      class="not-number-source-amount"
      *ngIf="isSourceAmountNotNumber()">
      {{ 'transfer_v2.checkout.error.non_number_amount' | translate }}
    </mat-error>
  </div>
  <span class="transfer-icon px-0 py-8 lg:px-10 lg:pt-14">
    <rd-shared-icon
      [iconSymbol]="'icon-icn-transfer'"
      [iconTheme]="'link'"></rd-shared-icon>
  </span>

  <div class="input-group target px-8 lg:mb-5 lg:px-0">
    <label class="amount-form-label mb-5" for="targetAmount">{{
      targetCurrency
    }}</label>
    <div class="target-input-container">
      <mat-form-field [color]="'accent'" class="mat-field">
        <input
          matInput
          class="target-amount"
          readonly="true"
          type="text"
          formControlName="targetAmount"
          [placeholder]="targetDenomination() | localizeNumber"
          aria-atomic="true"
          [attr.aria-label]="targetCurrency"
          [attr.aria-live]="'polite'"
          [attr.aria-disabled]="true" />
      </mat-form-field>
    </div>
    <mat-error class="required-target-amount" *ngIf="isTargetAmountEmpty()">{{
      'transfer_v2.checkout.error.required_amount' | translate
    }}</mat-error>
    <mat-error
      class="not-number-target-amount"
      *ngIf="isTargetAmountNotNumber()"
      >{{
        'transfer_v2.checkout.error.non_number_amount' | translate
      }}</mat-error
    >
  </div>
</div>
